import React, { useEffect, useState, useContext } from "react";
import axiosInstance from "../api/axios";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";

export default function SearchBox({ onItemClick, text = "Search users..." }) {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const { token } = useContext(AuthContext);

  const runSearch = async (searchQuery) => {
    const res = await axiosInstance.get(`/profiles/search/`, {
      params: { q: searchQuery },
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    return res.data.results || [];
  };

  const handleSearch = async () => {
    try {
      const users = await runSearch(query);
      setResults(users);
    } catch (err) {
      console.error("Search failed", err);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (query.trim()) {
        setLoading(true);

        runSearch(query)
          .then((users) => {
            setResults(users);
          })
          .catch((err) => {
            console.error("Search failed", err);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [query, token]);

  return (
    <div className="p-4 w-full mx-auto">
      <div className="flex space-x-2 mb-2 items-center">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={text}
          className="w-full px-3 py-2 border rounded-lg"
        />
        <button
          onClick={handleSearch}
          className="bg-black text-white h-9 px-5 py-1 rounded-full hover:bg-gray-800 transition"
        >
          <Search />
        </button>
      </div>
      {loading && (
        <div className="flex justify-center items-center my-2">
          <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <ul className="mt-4">
        {results.map((profile) => (
          <li
            key={profile.id}
            className="flex items-center space-x-4 py-2 border-b hover:text-blue-500"
            onClick={() => {
              onItemClick(profile);
              setResults([]);
            }}
          >
            <img
              src={profile.profile_pic_url || `${process.env.PUBLIC_URL}/logo512.png`}
              alt={profile.username}
              className="w-10 h-10 rounded-full object-cover border border-black flex-shrink-0"
            />
            <p>{profile.username}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
